import React from "react"
import "./Button.css"

const Button = React.forwardRef(({ className, variant = "default", size = "default", children, ...props }, ref) => {
  return (
    <button className={`button ${variant} ${size} ${className || ""}`} ref={ref} {...props}>
      {children}
    </button>
  )
})

Button.displayName = "Button"

export default Button

